<template>
  <header :class="[classCustom, 'flex-row', 'flex__between']">
    <slot name="filterByStatus">
      <div></div>
    </slot>
    <!-- <slot name="rightSection"> -->
    <user-header />
    <!-- </slot> -->
  </header>
</template>

<script>
export default {
  name: 'main-header',
  props: ['classCustom'],
  components: {
    userHeader: () => import('./user-header.vue')
  }
}
</script>

<style scoped>
.header-title {
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/header/main-header.vue